import { LOAD_SONG_LIST_REQUEST, LOAD_SONG_LIST_SUCCESS } from './songlist';
import { LOAD_SONG_SUCCESS, LOAD_SONG_FAILURE } from './song';

export const FIRESTORE_SONGLIST_FETCHING = 'FIRESTORE_SONGLIST_FETCHING';
export const FIRESTORE_SONGLIST_RECEIVED = 'FIRESTORE_SONGLIST_RECEIVED';
export const FIRESTORE_SONG_RECEIVED = 'FIRESTORE_SONG_RECEIVED';

// export const FIRESTORE_OPEN_SONG_REQUEST = 'FIRESTORE_OPEN_SONG_REQUEST';
// export const FIRESTORE_OPEN_SONG_SUCCESS = 'FIRESTORE_OPEN_SONG_SUCCESS';
// export const FIRESTORE_OPEN_SONG_FAILURE = 'FIRESTORE_OPEN_SONG_FAILURE';

export function firestoreSonglistFetching() {
  return { type: FIRESTORE_SONGLIST_FETCHING };
}

export function receivedfirestoreSonglist(songlist) {
  return { type: FIRESTORE_SONGLIST_RECEIVED, songlist, _syncTofirebase: false };
}

export function receivedUpdatedSongFromFirestore(obj) {
  console.log('re', obj);
  return {
    type: FIRESTORE_SONG_RECEIVED,
    obj,
    filename: obj.meta.filename,
    _syncTofirebase: false,
  };
}

export function openSongFromFireStore(filename) {
  return (dispatch, getState, { db }) => {
    dispatch({ type: LOAD_SONG_LIST_REQUEST, filename });
    return db
      .collection('songs')
      .doc(filename)
      .get()
      .then((doc) => {
        dispatch({
          type: LOAD_SONG_SUCCESS,
          filename,
          obj: doc.data(),
          _syncTofirebase: false,
        });
      })
      .catch((error) => {
        dispatch({ type: LOAD_SONG_FAILURE, filename, error });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/firestore.js